import React from "react";

interface RegisterShellProps {
  children: React.ReactNode;
}

export const RegisterShell: React.FC<RegisterShellProps> = ({ children }) => {
  return (
    <div className="h-[100dvh] overflow-hidden bg-gray-50 dark:bg-gray-900 lg:p-4">
      <div className="mx-auto flex h-full max-w-7xl flex-col overflow-hidden bg-white shadow-sm dark:bg-gray-900 lg:flex-row lg:rounded-2xl lg:border lg:border-gray-200 lg:dark:border-gray-700">
        {children}
      </div>
    </div>
  );
};

export default RegisterShell;

